import Handling from './Handling';
import HandlingActive from './HandlingActive';
import Comfort from './Comfort';
import Engine from './Engine';

const Scenes = {
    Handling,
    HandlingActive,
    Comfort,
    Engine,
};

export default Scenes;
